var resettingFilter = false,
    isPriceFiltered = false;

Eshop.confirm = function (text, options, callback) {
    var settings = $.extend({
        title: text,
        text: "",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: 'Zrušiť',
        confirmButtonColor: "#ec008c",
        confirmButtonText: "Ok",
        closeOnConfirm: true
    }, options);

    swal(settings, callback);
}

Event.on('Filter.reset', function () {
    resettingFilter = true;
    isPriceFiltered = false;
});

Event.on('Listing.fetchedData', function (data) {
    resettingFilter = false;
});


function addFormCustomRules(formSelector) {
    const $form = $(formSelector);

    if (!$form.length) {
        return false;
    }

    const formRules = $form.validate().settings.rules,
        customRules = {
            addressNumber: {
                addressNumber: true
            }
        };

    if (formSelector === '.js-form-reg') {
        formRules.billing_address = customRules.addressNumber;
        formRules.shipping_address = customRules.addressNumber;
        formRules.address = customRules.addressNumber;
    }

    $form.find('[name*="customer_addresses"]').each(function() {
        if (/customer_addresses.*address/.exec(this.name) !== null) {
            formRules[this.name] = customRules.addressNumber;
        }
    });
}

$(function () {
    Listing.customCallbacks.afterFetch = function () {
        bLazy.revalidate();
        setTimeout(function () {
            bLazy.revalidate();
        }, 100);

        if ($('.js-pager-current-count').length) {
            $('.js-pager-current-count').html($('.listing.products').first().find('.listing__item').length);
        }
    }
});

function updateProductShippingText(data) {
    $('.js-product-free-shipping-text').find('[data-element="cart"][data-type="free_shipping_text"]').each(function () {
        if ($(this).data('custom') == 'has_free_shipping' || data.free_shipping.price == 0) {
            $(this).html(data.free_shipping_product_text);
        } else if (!$.isEmptyObject(data.products)) {
            $(this).html(data.free_shipping.text);
        } else {
            $(this).html($('.js-product-free-shipping-text').data('init-text'));
        }

    });
}

Cart.customCallbacks.removedItem = function (elem, response) {
    $('.minicart').show();
    $('.header-minicart').attr('data-quantity', response.totals.quantity);

    updateProductShippingText(response);
}

Cart.customCallbacks.addedItem = function (form, response) {
    $('.header-minicart').attr('data-quantity', response.totals.quantity);

    updateProductShippingText(response);
}

Cart.customCallbacks.updatedItem = function (input, response) {
    updateProductShippingText(response);
}

const notifyAlertSettings = {
    allow_dismiss: true,
    type: 'success',
    animate: {
        enter: 'fadeInRight',
        exit: 'fadeOutLeft'
    },
    gap: 2,
    delay: 4500,
    mouse_over: 'pause',
    offset: {
        y: 30 + $('.sc-info-messages-wrapper').height(),
        x: 0
    },
    z_index: 350,
    template: `
        <div data-notify="container" class="notify custom {0}" role="alert" style="z-index:190;">
            <button type="button" aria-hidden="true" class="close" data-notify="dismiss"><i class="fa fa-times" aria-hidden="true"></i></button>
            <span class="message" data-notify="message">{2}</span>
        </div>
    `
};

var spinNotify;
Eshop.alert = function (msg, options) {
    var settings = Object.assign({}, notifyAlertSettings);

    $.extend(settings, options);

    if (settings.type == 'danger') {

        if ($('.notify.danger').size() > 0) {
            if (
                $('.notify.danger .message').filter(function () {
                    return $(this).html() == msg;
                }).size() > 0
            ) {
                return false;
            }
        }

        var stockErrorMessage = $('.out_of_stock_message').html();

        if (msg.replace(/ [0-9]+ ks/, '') == stockErrorMessage.replace(" :productStock ks", '')) {
            settings.delay = false;

            if (spinNotify != undefined && $(spinNotify.$ele).is(':visible')) {
                spinNotify.update('message', msg);
            } else {
                spinNotify = $.notify(msg, settings);
            }

            return false;
        }
    }

    $.notify(msg, settings);
}

$(function () {
    setTimeout(function () {
        jQuery.validator.addMethod("email", function (value, element) {
            return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || value == '';
        });

        jQuery.validator.addMethod("phone", function (value, element) {
            return /^[0-9+][0-9 ]{8,17}$/.test(value.replace(/\s/g, '')) || value == '';
        });

        jQuery.validator.addMethod("exactLengthWithoutSpaces", function (value, element, param) {
            return value.replace(/\s/g, '').length == param;
        }, jQuery.validator.messages.exactlength);

        jQuery.validator.addMethod("postCode", function(value, element) {
            return !/[^\s0-9-]/.test(value) || value == '';
        });

        jQuery.validator.addMethod("addressNumber", function (value, element) {
            //? ak to bude nutne, spravi sa validacka pre jednotlive krajiny
            return /[^0-9 ].\d/.test(value.trim()) || value == '';
        });

        if ($('.js-form-reg').length) {
            $('.js-form-reg').validate().settings.rules.post_code = {
                digitsWithSpaces: true,
                exactLengthWithoutSpaces: 5
            };
        }

        addFormCustomRules('.js-form-reg');
        addFormCustomRules('.js-account-addresses');
        addFormCustomRules('.js-account-addresses-modal');
    }, 0);
});

var filterElem = document.getElementById("filter");

if (filterElem !== null) {
    filterElem.addEventListener("category.changed", function (e) {
        var categoryId = e.detail.category_id;

        document.getElementById('filterCategoryId').value = categoryId;
        Filter.submit();
    });

    filterElem.addEventListener("category.updated", function (e) {
        var category = e.detail.category;
        var headElem = document.getElementsByTagName('h1')[0];
        var heading = headElem.innerText;

        if (headElem.dataset.original === undefined) {
            headElem.dataset.original = heading;
        }

        headElem.innerText = headElem.dataset.original;
        if (category) {
            headElem.innerText += " - " + category.name;
        }
    });
}

Cart.init()